import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { ConfigProvider } from 'antd';
import classNames from 'classnames';
import { useContext } from 'react';
import { clearMenuItem } from '../../utils/utils';
import { AppsLogoComponents, defaultRenderLogo } from '../AppsLogoComponents';
import { renderLogoAndTitle } from '../SiderMenu/SiderMenu';
import { TopNavHeader } from '../TopNavHeader';
import { RightContent } from './RightContent';
import { useStyle } from './style';

var renderLogo = function renderLogo(menuHeaderRender, logoDom) {
  if (menuHeaderRender === false) {
    return null;
  }

  if (menuHeaderRender) {
    return menuHeaderRender(logoDom, null);
  }

  return logoDom;
};

var GlobalHeader = function GlobalHeader(props) {
  var _classNames;

  var isMobile = props.isMobile,
      logo = props.logo,
      collapsed = props.collapsed,
      onCollapse = props.onCollapse,
      rightContentRender = props.rightContentRender,
      menuHeaderRender = props.menuHeaderRender,
      onMenuHeaderClick = props.onMenuHeaderClick,
      propClassName = props.className,
      style = props.style,
      layout = props.layout,
      children = props.children,
      splitMenus = props.splitMenus,
      menuData = props.menuData,
      prefixCls = props.prefixCls;

  var _useContext = useContext(ConfigProvider.ConfigContext),
      direction = _useContext.direction;

  var baseClassName = "".concat(prefixCls, "-global-header");

  var _useStyle = useStyle(baseClassName),
      wrapSSR = _useStyle.wrapSSR,
      hashId = _useStyle.hashId;

  var className = classNames(propClassName, baseClassName, hashId);

  if (layout === 'mix' && !isMobile && splitMenus) {
    var noChildrenMenuData = (menuData || []).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        children: undefined,
        routes: undefined
      });
    });
    var clearMenuData = clearMenuItem(noChildrenMenuData);
    return _jsx(TopNavHeader, _objectSpread(_objectSpread({
      mode: "horizontal"
    }, props), {}, {
      splitMenus: false,
      menuData: clearMenuData
    }));
  }

  var logoClassNames = classNames("".concat(baseClassName, "-logo"), hashId, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "-logo-rtl"), direction === 'rtl'), _defineProperty(_classNames, "".concat(baseClassName, "-logo-mix"), layout === 'mix'), _defineProperty(_classNames, "".concat(baseClassName, "-logo-mobile"), isMobile), _classNames));

  var logoDom = _jsx("span", {
    className: logoClassNames,
    children: _jsx("a", {
      children: defaultRenderLogo(logo)
    })
  }, "logo");

  return wrapSSR(_jsxs("div", {
    className: className,
    style: _objectSpread({}, style),
    children: [isMobile && renderLogo(menuHeaderRender, logoDom), isMobile && _jsx("span", {
      className: "".concat(baseClassName, "-collapsed-button ").concat(hashId),
      onClick: function onClick() {
        onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(!collapsed);
      },
      children: collapsed ? _jsx(MenuUnfoldOutlined, {}) : _jsx(MenuFoldOutlined, {})
    }), layout === 'mix' && !isMobile && _jsxs(_Fragment, {
      children: [_jsx(AppsLogoComponents, _objectSpread({}, props)), _jsx("div", {
        className: logoClassNames,
        onClick: onMenuHeaderClick,
        children: renderLogoAndTitle(_objectSpread(_objectSpread({}, props), {}, {
          collapsed: false
        }), 'headerTitleRender')
      })]
    }), _jsx("div", {
      style: {
        flex: 1
      },
      children: children
    }), (rightContentRender || props.actionsRender || props.avatarProps) && _jsx(RightContent, _objectSpread({
      rightContentRender: rightContentRender
    }, props))]
  }));
};

export { GlobalHeader };